const actions = {
  toggleModal (context) {
    context.commit('TOGGLE_MODAL')
  },
  setSelectedItem (context, item) {
    context.commit('SET_SELECTED_ITEM', item)
  },
  toggleRange (context) {
    context.commit('TOGGLE_RANGE')
  },
  setSelectedRange (context, item) {
    context.commit('SET_SELECTED_RANGE', item)
  }
}

export default actions
